import JSZip from "jszip";
import { injectExif } from "./exif";

const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
const toCsv = (rows) => rows.map((r) => r.map(esc).join(",")).join("\n");
const slug = (s) => String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 60);
const htmlEsc = (s) => String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

const blobToDataUrl = (blob) => new Promise((resolve, reject) => {
  const r = new FileReader();
  r.onload = () => resolve(r.result);
  r.onerror = () => reject(r.error);
  r.readAsDataURL(blob);
});

export const descriptionsCsv = (items) =>
  toCsv([["filename", "title", "tags", "alt_text"], ...items.map((r) => [r.name, r.ai.title, r.ai.tags.join("; "), r.ai.alt_text])]);

const SHOPIFY_HEAD = ["Handle", "Title", "Body (HTML)", "Vendor", "Product Category", "Type", "Tags", "Published",
  "Option1 Name", "Option1 Value", "Variant SKU", "Variant Grams", "Variant Inventory Tracker", "Variant Inventory Policy",
  "Variant Fulfillment Service", "Variant Price", "Variant Requires Shipping", "Variant Taxable", "Image Src",
  "Image Position", "Image Alt Text", "Status"];

// Draft products, price left blank so it is set in Shopify before publishing.
export const shopifyCsv = (items) => {
  const seen = new Set();
  const rows = items.map((r, i) => {
    let handle = slug(r.ai.title) || `product-${i + 1}`;
    while (seen.has(handle)) handle = `${handle}-${i + 1}`;
    seen.add(handle);
    return [handle, r.ai.title, `<p>${htmlEsc(r.ai.alt_text)}</p>`, "", "", "", r.ai.tags.join(", "), "FALSE",
      "Title", "Default Title", r.name.replace(/\.[^.]+$/, ""), "", "", "deny", "manual", "", "TRUE", "TRUE", "",
      "", r.ai.alt_text, "draft"];
  });
  return toCsv([SHOPIFY_HEAD, ...rows]);
};

// Rebuild the ZIP from processed results; edited AI copy is re-written into each file's EXIF.
export async function buildBatchZip(prefix, list) {
  const results = list.map((r) => (r.ai ? { ...r, ai: { ...r.ai, title: r.ai.title.trim(), alt_text: r.ai.alt_text.trim(),
    tags: r.ai.tags.map((t) => t.trim()).filter(Boolean) } } : r));
  const zip = new JSZip();
  const folder = zip.folder(prefix || "batch");
  for (const r of results) {
    if (r.edited && r.ai) {
      const dataUrl = injectExif(await blobToDataUrl(r.blob), { ...r.meta, ai: r.ai });
      folder.file(r.name, await (await fetch(dataUrl)).blob());
    } else {
      folder.file(r.name, r.blob);
    }
  }
  const withAi = results.filter((r) => r.ai);
  if (withAi.length) {
    folder.file("product-descriptions.csv", descriptionsCsv(withAi));
    folder.file("shopify-products.csv", shopifyCsv(withAi));
  }
  return zip.generateAsync({ type: "blob" });
}
